<template>
  <div>
    <div class="container-fluid checkout-main py-3">
      <div class="row">
        <div class="container-fluid checkout-content">
          <!-- <div
						class="success_message"
						v-text="this.$root.success_message"
						v-if="this.$root.success_message != ''"
					></div>
					<!-- <div
						class="error_message"
						v-text="this.$root.error_message"
						v-if="this.$root.error_message != ''"
					></div> -->
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <!--login section start here-->
              <div class="login-section opc-section" id="login-section">
                <h3 class="section-title font-medium">Login / Sign up</h3>
                <form class="login-form text-center">
                  <div
                    class="field mobile fieldLogin text-left mb-3"
                    v-bind:class="{
                      success: this.mobile === true,
                      error: this.mobile_error != '',
                    }"
                  >
                    <!-- <label class="label"><span>Mobile Number</span></label> -->
                    <input
                      maxlength="10"
                      class="input-text form-control"
                      autocomplete="off"
                      v-model="mobile_number"
                      placeholder="Mobile Number"
                      name="mobile"
                      autofocus
                    />
                    <p class="size_error" v-text="mobile_error"></p>
                  </div>
                  <button
                    type="btn"
                    class="getYourOtp"
                    v-if="!isOtp"
                    @click.prevent="mobile_no"
                  >
                    <span v-if="!isSentOTP"> Get OTP </span>
                    <span v-else>
                      <i class="fa fa-spinner btnLoader"></i>
                    </span>
                  </button>
                  <div
                    v-if="isOtp"
                    class="field otp fieldLogin text-left"
                    v-bind:class="{
                      success: this.otp === true,
                      error: this.otp_error != '',
                    }"
                  >
                    <!-- <label class="label"
											><span>One Time Password (OTP)</span></label
										> -->
                    <input
                      placeholder="One Time Password (OTP)"
                      class="input-text form-control"
                      maxlength="4"
                      type="text"
                      name="customerpassword"
                      v-model="otp_number"
                      :disabled="this.mobile == false"
                      autocomplete="off"
                      ref="otpLoginHeader"
                    />
                    <a
                      href="#"
                      class="action float-right py-2 text-logo-color"
                      id="resend"
                      @click.prevent="resend_otp()"
                      v-if="this.mobile === true && this.resend_otp_time === 60"
                      ><span>Resend OTP </span></a
                    >
                    <p class="size_error" v-text="otp_error"></p>
                    <label class="timer-main font-medium">
                      <!-- <span>Please enter the OTP sent on your mobile</span> -->
                      <span
                        class="timer-container"
                        v-if="
                          this.mobile === true && this.resend_otp_time != 60
                        "
                        ><span>00:</span
                        ><span
                          class="timer"
                          v-text="this.resend_otp_time"
                        ></span
                      ></span>
                    </label>
                  </div>
                </form>
              </div>
              <!--login section end here-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style >
.fieldLogin {
  width: 100% !important;
  background: none !important;
  position: relative;
  padding-left: 0 !important;
}
.action.otp-resend-button {
  position: absolute;
  right: 17px;
  top: 32px;
  color: var(--main-color);
  padding: 5px 15px;
}

@media screen and (max-width: 767px) {
  .action.otp-resend-button {
    font-size: 12px;
    top: 33px;
    right: 5px;
  }
}
</style>

<script>
import axios from "axios";
export default {
  name: "login",
  data() {
    return {
      isSentOTP: false,
      mobile_number: "",
      mobile_error: "",
      mobile: false,
      otp_number: "",
      otp_error: "",
      otp: false,
      from_path: "",
      resend_otp_time: 60,
      isOtp: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from_path = from.path;
    });
  },
  methods: {
    countDownTimer() {
      if (this.resend_otp_time > 0) {
        setTimeout(() => {
          this.resend_otp_time -= 1;
          this.countDownTimer();
        }, 1000);
      }
      if (this.resend_otp_time == 0) {
        this.resend_otp_time = 60;
      }
    },
    // getAddress(){
    // 	console.log("called");
    // 	var form = new FormData();
    // 		form.append("customer_id", this.$root.customer_id);
    // 		form.append("customer_session", this.$root.customer_session);
    // 		form.append("store", this.$root.store);
    // 		axios
    // 				.post(this.$root.cart_api + "/customer/get-last-addresses", form)
    // 			.then((response) => {
    // 				if (response.data.success === true) {
    // 					console.log(response);
    // 				this.$root.locationAddresses = response.data.data
    // 				}
    // 			}).catch(err=>{

    // 			})

    // },
    resend_otp() {
      this.$root.error_message = "";
      this.$root.success_message = "";
      this.resend_otp_time = 60;
      this.otp_number = "";
      this.countDownTimer();
      var form = new FormData();
      form.append("phone", this.mobile_number);
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      axios
        .post(this.$root.cart_api + "/customer/send-otp", form, config)
        .then((response) => {
          if (response.data.success === true) {
            this.otp_number = "";

            this.$toast.success(response.data.message, {
              position: "top-right",
              duration: 4000,
            });
            // this.$root.success_message = response.data.message;
            this.$root.error_message = "";
          } else {
            this.$toast.error(response.data.message, {
              position: "top-right",
              duration: 4000,
            });
            // this.$root.error_message = response.data.message;
            this.$root.success_message = "";
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },
    pushnotification(customerId){

			let pushtoken=  $cookies.get(
              window.location.hostname.substring(10, 4) + "_devicetoken"
            );
	     let platform=$cookies.get(
              window.location.hostname.substring(10, 4) + "_platform"
            );
				var form = new FormData();
				form.append("fcm_device_token", pushtoken);
        form.append("customer_id", customerId);
				form.append("platform", platform);
				axios.post(`${this.$root.admin_api}/push-notification`,form)
				.then((res) => {
					console.log(res)
				})
				.catch((err) => {
					console.log(err)		
				});


    },
    mobile_no() {
      this.resend_otp_time = 60;
      var phoneno = /^([0-9]{10,})+$/;
      if (this.mobile_number.match(phoneno)) {
        this.mobile_error = "";
        if (this.mobile_number.length == "10") {
          this.mobile = true;
          this.$root.error_message = "";
          this.$root.success_message = "";

          var form = new FormData();
          form.append("phone", this.mobile_number);
          let config = { headers: { "Content-Type": "multipart/form-data" } };
          this.isSentOTP = true;
          axios
            .post(this.$root.cart_api + "/customer/send-otp", form, config)
            .then((response) => {
              this.isSentOTP = false;
              if (response.data.success === true) {
                this.isOtp = true;
                this.$toast.success(response.data.message, {
                  position: "top-right",
                  duration: 4000,
                });
                // this.$root.success_message = response.data.message;
                this.$root.error_message = "";
                this.$gtm.trackEvent({
                  event: "Login",
                  category: "Login",
                  action: "OTP Sent",
                });
                setTimeout(() => {
                  this.$refs.otpLoginHeader.focus();
                }, 100);
              } else {
                this.$toast.error(response.data.message, {
                  position: "top-right",
                  duration: 4000,
                });
                // this.$root.error_message = response.data.message;
                this.$root.success_message = "";
              }
            })
            .catch((error) => {
              this.isSentOTP = false;
              this.$root.page_loader = false;
              if (error.message === "Network Error") {
                this.$root.error_message =
                  "Oops there seems to be some Network issue, please try again.";
              }
              window.scrollTo(0, 0);
            });
        } else {
          this.mobile = false;
          this.otp = false;
          this.otp_number = "";
        }
      } else {
        this.mobile = false;
        this.mobile_error = "Please enter valid mobile number";
      }
    },
  },

  created() {
    // window.scrollTo(0, 0);
    //  if(this.$root.customer_id != null && this.$root.customer_id != ''){
    //    this.$router.push('account-dashboard.html')
    //  }
    this.$root.error_message = "";
    this.$root.success_message = "";
    //this.$root.page_loader = false;
  },
  watch: {
    otp_number: {
      handler: function (after, before) {
        var otpno = /^\d*(?:\.\d{1,2})?$/;
        if (this.otp_number.match(otpno)) {
          this.otp_error = "";
          if (this.otp_number.length == "4") {
            this.$root.error_message = "";
            this.$root.success_message = "";
            // this.$root.page_loader = true;
            this.otp = true;
            this.$root.customer_id = "";
            var form = new FormData();
            form.append("phone", this.mobile_number);
            if (this.$root.pcart != null && this.$root.pcart != "") {
              form.append("pcart", this.$root.pcart);
            }
            form.append("store", this.$root.store);
            form.append("otp", this.otp_number);
            axios
              .post(this.$root.cart_api + "/customer/validate-otp", form)
              .then((response) => {
                if (response.data.success) {
                    this.pushnotification(response.data.data.customer.id)
                  this.$root.location.lat = $cookies.get(
                    window.location.hostname.substring(10, 4) + "_location_lat"
                  );
                  this.$root.location.long = this.$root.location.lat =
                    $cookies.get(
                      window.location.hostname.substring(10, 4) +
                        "_location_long"
                    );
                  if (
                    this.$root.location.lat != null &&
                    this.$root.location.long != null
                  ) {
                    this.$root.isLocation = true;
                  }
                  else{
                    localStorage.removeItem("location-landing");
                    this.$root.isLocation = false;
                  }
                  this.otp_number = "";
                  this.isOtp = false;
                  //    console.log(response.data);
                  this.$root.login_popup = false;
                  // this.isOtp = false

                  // this.$store.dispatch('getLogin', false)
                  this.$root.page_loader = false;
                  this.$root.error_message = "";
                  this.$toast.success(response.data.message, {
                    position: "top-right",
                    duration: 4000,
                  });
                  // this.$root.success_message = response.data.message;
                  // console.log(response.data.data.customer);
                  // console.log(response.data.email==;
                  // console.log(response.data.data.customer.id);
                  this.$root.wishListProducts =
                    response.data.data[0].wishlist_count;

                  if (response.data.data.customer != undefined) {
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_customer",
                      response.data.data.customer.id,
                      "1y"
                    );
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cs",
                      response.data.data.customer_session,
                      "1y"
                    );
                    this.$root.customer_id = response.data.data.customer.id;
                    // console.log(this.$root.customer_id);
                    this.$root.customer_session =
                      response.data.data.customer_session;
                    this.$root.customer_detail = response.data.data.customer;
                    this.$root.customerDetails.name = response.data.data
                      .customer.full_name
                      ? response.data.data.customer.full_name
                      : "";
                    this.$root.customerDetails.number =
                      response.data.data.customer.phone;
                    // this.getAddress()
                  } else {
                    // console.log(response.data);

                    this.$root.wishListProducts =
                      response.data.data[0].wishlist_count;
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_customer",
                      response.data.data.customer.id,
                      "1y"
                    );
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cs",
                      response.data.data[0].customer_session,
                      "1y"
                    );
                    this.$root.customer_id = response.data.data.customer.id * 1;
                    this.$root.customer_session =
                      response.data.data[0].customer_session;
                    this.$root.customerDetails.name =
                      response.data.data.customer.full_name;
                    this.$root.customerDetails.number =
                      response.data.data.customer.phone;
                    // this.getAddress()
                  }

                  if (response.data.data.pcart) {
                    this.$root.cart_product = response.data.data.products;

                    this.$root.pcart = response.data.data.pcart;

                    this.$root.thankyou_cart = response.data.data.pcart;

                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      response.data.data.pcart,
                      "1y"
                    );

                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_carts",
                      response.data.data.cart_session,
                      "1y"
                    );

                    this.$root.cart_session = response.data.data.cart_session;

                    this.$root.customerDetails.name =
                      response.data.data.customer.full_name;

                    this.$root.customerDetails.number =
                      response.data.data.customer.phone;
                  }

                  if (response.data.data.address.length) {
                    this.$root.address = response.data.data.address;

                    if (
                    this.$root.location.lat != null &&
                    this.$root.location.long != null
                    ) {
                    this.$root.isLocation = true;
                    }
                     else{
                    this.$root.location.lat =
                      response.data.data.address[0].latitude;
                    this.$root.location.long =
                      response.data.data.address[0].longitude;

                    $cookies.set(
                      window.location.hostname.substring(10, 4) +
                        "_location_lat",
                      this.$root.location.lat,
                      "1y"
                    );
                    $cookies.set(
                      window.location.hostname.substring(10, 4) +
                        "_location_long",
                      this.$root.location.long,
                      "1y"
                    );
                    }
                  
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_pin",
                      this.$root.address[0].pin_code
                    );

                    // this.$root.addressExistNotification=true;

                    for (let i = 0; i < this.$root.address.length; i++) {
                      if (i == 0) {
                        this.$root.address_id = this.$root.address[i].id;
                        this.$root.select_address_no = i;
                        break;
                      }
                    }
 
                    this.$root.isLocation = true;
                    var locationlanding = localStorage.getItem("location-landing");
                    console.log("locationlanding",locationlanding)
                    if(locationlanding==null){
                    window.localStorage.setItem("notification-flag", 1);
                    }
                    document
                      .getElementById("pim_main")
                      .classList.remove("landingPage");
                      
                    window.location.reload();
                  }
                  
                  window.location.reload()
                  this.$gtm.trackEvent({
                    event: "Login",
                    category: "Login",
                    action: "Login Success",
                  });
                  this.$gtm.trackEvent({
                    event: "Login_status",
                    category: "Login_status",
                    action: "Login Success",
                    Mobile_no: this.$root.customer_detail.phone,
                    Email: this.$root.customer_detail.email,
                  });
                  //this.$router.push(this.from_path);
                } else {
                  console.log("8");
                  this.$root.success_message = "";
                  this.$root.page_loader = false;
                  this.$toast.error(response.data.message, {
                    position: "top-right",
                    duration: 4000,
                  });
                  // this.$root.error_message = response.data.message;
                  this.$root.customer_id = "";
                  this.$gtm.trackEvent({
                    event: "Login",
                    category: "Login",
                    action: "Login Failure",
                    label: response.data.message,
                  });
                }
              })
              .catch((error) => {
                this.$root.page_loader = false;
                if (error.message === "Network Error") {
                  this.$root.error_message =
                    "Oops there seems to be some Network issue, please try again.";
                }
                window.scrollTo(0, 0);
              });
          } else {
            this.otp = false;
          }
        } else {
          this.otp = false;
          this.otp_error = "Please enter valid OTP";
        }
      },
    },
  },
};
</script>